import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
// SPDX-FileCopyrightText: 2025 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import { useEffect } from "react";
import { TabbedShowLayout, useRecordContext } from "react-admin";
import ElectionHeader from "../../components/ElectionHeader";
import { EditCandidateData } from "./EditCandidateData";
import { useElectionEventTallyStore } from "@/providers/ElectionEventTallyProvider";
import { useAliasRenderer } from "@/hooks/useAliasRenderer";
import { configuredLanguage, useInheritedLanguage } from "@/hooks/usePresentationName";
export var CandidateTabs = function () {
    var _a;
    var record = useRecordContext();
    var aliasRenderer = useAliasRenderer();
    var inheritedLanguage = useInheritedLanguage(record);
    var _b = useElectionEventTallyStore(), setCandidateIdFlag = _b.setCandidateIdFlag, setContestIdFlag = _b.setContestIdFlag, setElectionEventIdFlag = _b.setElectionEventIdFlag;
    useEffect(function () {
        if (record) {
            setCandidateIdFlag(record.id);
            setContestIdFlag(record.contest_id);
            setElectionEventIdFlag(record.election_event_id);
        }
    }, [record]);
    return (_jsxs(_Fragment, { children: [_jsx(ElectionHeader, { title: aliasRenderer(record, (_a = configuredLanguage(record)) !== null && _a !== void 0 ? _a : inheritedLanguage) || "", subtitle: "candidateScreen.common.subtitle" }), _jsx(TabbedShowLayout, { children: _jsx(TabbedShowLayout.Tab, { label: "Data", children: _jsx(EditCandidateData, { record: record }) }) })] }));
};
